<template></template>

<script>
export default {
	name: "ChatPicturePaster",

	methods: {
		// 粘贴事件
		paster(e) {
			const pictureData = this.getPicture(e);

			if (pictureData) {
				this.showConfirm(pictureData.blob, pictureData.blobUrl);
			}
		},

		// 从粘贴事件获取图片数据
		getPicture(event) {
			let clipboardData = event.clipboardData || event.originalEvent.clipboardData;

			if (clipboardData.items) {
				let items = clipboardData.items,
					len = items.length,
					blob = null;

				for (let i = 0; i < len; i++) {
					if (items[i].type.indexOf("image") !== -1) {
						//getAsFile() 此方法只是living standard firefox ie11 并不支持
						blob = items[i].getAsFile();
					}
				}

				if (blob !== null) {
					let blobUrl = URL.createObjectURL(blob);

					return { blob: blob, blobUrl: blobUrl };
				} else {
					return null;
				}
			}

			return null;
		},

		// 显示发送确认框
		showConfirm(blob, blobUrl) {
			const html = "<div><img src=" + blobUrl + ' style="width:auto;height:auto;max-width:100%;max-height:100%;"></img></div>';

			this.$confirm(html, this.$t("chatPicturePaster.sendThisImage"), {
				confirmButtonText: this.$t("chatPicturePaster.send"),
				cancelButtonText: this.$t("common.cancel"),
				dangerouslyUseHTMLString: true,
				closeOnClickModal: false,
				center: true,
			})
				.then(() => {
					this.$emit("onUpload", blob);
				})
				.catch(() => {
					// cancel btn
				});
		},
	},
};
</script>

<style lang="less" scoped></style>
